import { EmailThread } from "../../../Components/MailApp/MailAppInterfaces";

export const ActivistMailContent: EmailThread[] = [
  {
    Emails: [
      {
        Date: "28 Jan 2024",
        Time: "7:16 AM",
        Author: "farkasandsons@mail.com",
        Receiver: "bluedolphin7@mail.com",
        Subject: "Urgent Contact About Inheritance",
        Text: `Dear Nicolas,
  
  Please forgive me if I am mistaken, but I, Grant Holmes, have strong reason to believe that the owner of this email address is Nicolas Astor. I would not write to you in this way if I was not practically certain that this was you. Our team has been working night and day to find a means of contacting you. I am contacting you by email only for want of knowing your telephone contact number. Naturally, we do not have your up-to-date records in our books.
  
  I am writing to you personally on behalf of Farkas & Sons, of New Jersey, USA. We at Farkas & Sons proudly support and represent the Astor family in financial and legal matters. 
  
  I very much hope that the tragic news of your mother and father, Alexander and Eleanor’s, sudden passing has reached you already. All of us here at Farkas & Sons send our deepest condolences. 
  
  An important clause in your father’s will obliges us, the executors of that will, to stop at nothing to try to contact you in the case of his passing. Despite everything, your father retained a slither of hope that you may still be alive, and that you might attempt to contact the family in the event of his passing. 
  
  It is now my legal responsibility to bring to your attention the fact that as your father’s only male child, you stand in line to inherit all of your father’s fortune, if you wish to do so. Even after your disappearance, your father did not want to change family tradition. Your sister, Madeleine, has been duly informed that she has been cut out of the will and to suggest she is not best pleased would be a sincere understatement. If you choose not to inherit, of course, your sister stands to inherit the entire fortune.
  
  I would love nothing more than to continue explaining the extraordinary efforts your father took not to write you out of his will despite strong opposition from within the family. However, time is short.
  
  Legally, you have precisely 14 days from the day of his passing to make contact with us. As such, you have 10 days remaining.
  
  Kind Regards,
  
  Grant Holmes`,
        Signature: `  You can reply to us on this email, contact us by telephone on (535) 917 2267, or visit us in person at the following address: 2525 Ash Avenue, Cherry Hill, NJ 08002.`,
      },
      {
        Date: "1 Feb 2024",
        Time: "2:36 PM",
        Author: "bluedolphin7@mail.com",
        Receiver: "farkasandsons@mail.com",
        Subject: "Re: Urgent Contact About Inheritance",
        Text: `Dear Grant, 
  
  Please let me know when you can call. My mobile is: +1 5681 724099. I am available all afternoon.
  
  Nick`,
      },
      {
        Date: "1 Feb 2024",
        Time: "2:40 PM",
        Author: "farkasandsons@mail.com",
        Receiver: "bluedolphin7@mail.com",
        Subject: "Re: Urgent Contact About Inheritance",
        Text: `Dear Nicolas, 
  
  I am calling you now.
  
  Grant`,
      },
      {
        Date: "1 Feb 2024",
        Time: "4:19 PM",
        Author: "bluedolphin7@mail.com",
        Receiver: "farkasandsons@mail.com",
        Subject: "Re: Urgent Contact About Inheritance",
        Text: `Dear Grant,
  
  I appreciate everything you’re doing for me. Please contact my mobile from now on whenever you need me as I am easier to reach from there.
  
  Excited to get these papers signed.
  
  Nick`,
      },
    ],
  },
];
